module.exports = __webpack_public_path__ + "media/dashboard/assets/images/setting-0b82b38157c77956fee5e6dadabe57b0.png";